module.exports = __webpack_public_path__ + "static/img/fondoesperanza.756e0909.svg";